import React, { useState, useEffect } from 'react';

const Navbar = () => {
    const [scrolled, setScrolled] = useState(false);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 20);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollToSection = (id) => {
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
            setMobileMenuOpen(false);
        }
    };

    return (
        <nav
            className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${scrolled ? 'bg-dark-900/80 backdrop-blur-xl border-b border-white/5 py-3 shadow-lg' : 'bg-transparent py-6'
                }`}
        >
            <div className="container mx-auto px-6 flex justify-between items-center">

                {/* Logo */}
                <div className="flex flex-col cursor-pointer group" onClick={() => scrollToSection('home')}>
                    <h2 className="text-xl md:text-2xl font-display font-black tracking-widest text-white leading-none group-hover:first-letter:text-royal-500 transition-colors">
                        MD SAMSUDDIN
                    </h2>
                    <span className="text-xs md:text-sm font-sans tracking-[0.3em] text-royal-500 font-bold mt-1 group-hover:text-royal-400 transition-colors">
                        SHUTTERS
                    </span>
                </div>

                {/* Desktop Menu */}
                <ul className="hidden md:flex space-x-12">
                    {['Home', 'Products', 'Features', 'Contact'].map((item) => (
                        <li key={item}>
                            <button
                                onClick={() => scrollToSection(item.toLowerCase())}
                                className="text-sm font-bold uppercase tracking-widest text-gray-300 hover:text-royal-500 transition-colors relative group"
                            >
                                {item}
                                <span className="absolute -bottom-1 left-0 w-0 h-[2px] bg-royal-500 transition-all duration-300 group-hover:w-full"></span>
                            </button>
                        </li>
                    ))}
                </ul>

                {/* Mobile Menu Toggle */}
                <button
                    className="md:hidden flex flex-col space-y-1.5 p-2 z-50"
                    onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                >
                    <span className={`block w-8 h-0.5 bg-white transition-all duration-300 ${mobileMenuOpen ? 'rotate-45 translate-y-2' : ''}`}></span>
                    <span className={`block w-6 h-0.5 bg-royal-500 ml-auto transition-all duration-300 ${mobileMenuOpen ? 'opacity-0' : ''}`}></span>
                    <span className={`block w-8 h-0.5 bg-white transition-all duration-300 ${mobileMenuOpen ? '-rotate-45 -translate-y-2' : ''}`}></span>
                </button>

                {/* Mobile Overlay Menu */}
                <div className={`fixed inset-0 bg-dark-900/95 backdrop-blur-2xl z-40 flex flex-col justify-center items-center space-y-8 transition-all duration-500 transform ${mobileMenuOpen ? 'translate-x-0 opacity-100' : 'translate-x-full opacity-0'}`}>
                    {['Home', 'Products', 'Features', 'Contact'].map((item) => (
                        <button
                            key={item}
                            onClick={() => scrollToSection(item.toLowerCase())}
                            className="text-3xl font-display font-bold text-white hover:text-royal-500 hover:scale-110 transition-all duration-300"
                        >
                            {item}
                        </button>
                    ))}
                </div>
            </div>
        </nav>
    );
};

export default Navbar;
